<template>
  <div class="Header">
    <!-- 头部 -->
    <div class="header">
      <div class="w">
        <a href="javascript:;" @click="goIndex()">
          <img class="sy-logo" :src="logoUlr" alt="云闪印" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      logoUlr: ''
    }
  },
  methods: {
    goIndex() {
      this.$router.push('/index')
    },
    async queryInfo() {
      const { data: res } = await this.$http.get('/api/index/apidata')
      this.logoUlr = res.data.logo
      $('.beian').text(res.data.beian)
      let sy_info = {
        logo: res.data.logo,
        beian: res.data.beian
      }
      window.sessionStorage.setItem('sy_info', JSON.stringify(sy_info))
    }
  },
  created() {
    this.queryInfo()
  }
}
</script>

<style lang="less" scoped>
.header {
  height: 90px;
  line-height: 90px;
  background-color: #fff;
}
.sy-logo {
  width: 120px;
}
</style>
